export default {
  Home: "/"
};
